import { FC } from 'react';
import {
  Link,
  LinkProps,
  useMatch,
  useResolvedPath
} from 'react-router-dom';
import { getFullPath } from '@app/utilities';

// Extends from main `LinkProps` so we can pass any of their props to this component.
interface CustomRouterLinkProps extends LinkProps {
  /**
   * A `string` representing the route that this link should redirect to.
   * Internally it's converted to a `To` from `react-router-dom`
   * to avoid losing search params, query params, or hash.
   */
  to: string;
  /**
   * The label to render inside the anchor element.
   */
  label: string;
  /**
   * A CSS class that's added to the parent `li` element.
   */
  parentClassName?: string;
}

export const CustomRouterLink: FC<CustomRouterLinkProps> = ({
  to,
  label,
  parentClassName = 'nav-button',
  ...rest
}: CustomRouterLinkProps) => {
  // Match on resolved path segments (not a substring of the pathname) so that,
  // e.g., `import` isn't marked active while viewing `management/import-from-csv`.
  // `end: false` keeps a parent tab active on its nested routes.
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: false }) != null;

  return (
    <li className={`${parentClassName} ${(isActive) ? 'active' : ''}`}>
      <Link to={getFullPath(to)} {...rest}>{label}</Link>
    </li>
  );
};
